import { FileToUpload } from './filetoupload';
import { OnboardVrifications } from './OnboardVrifications';
import { OnboardEmpAddressDetail } from './OnboardEmpAddressDetail';
import { ProfileImageUpload } from './ProfileImageUpload';

export class OnboardEmployeeDetails {
  EmpId: number;
  FirstName: string;
  MiddleName: string;
  LastName: string;
  NamePerRecords: string;
  DOB: Date;
  CelebratedDOB: Date;
  Gender: string;
  TemporaryAddress: OnboardEmpAddressDetail = new OnboardEmpAddressDetail(); 
  PermanentAddress: OnboardEmpAddressDetail = new OnboardEmpAddressDetail(); 
  MobileNumber: string;
  PAN: string;
  Aadhar: string; 
  BloodGroup: string; 
  AadharFilePath: string; 
  AadharFileName: string;
  PanFilePath: string;
  PanFileName: string;
  Aadharfile: FileToUpload;
  Panfile: FileToUpload;
  WhatsAppNumber: string;
  Title: string;
  ProfileFileName: string;
  ProfileFilePath: string;
  Profilefile: ProfileImageUpload;
  LinkedInID: string;
  ResumeDocumentPath: string;
  ResumeDocumentName: string;
  ResumeFile: FileToUpload;
  onboardVrifications: OnboardVrifications = new OnboardVrifications();
  City: any;
  GroupId: string;
  Type: string;
  Email: string;
  CreatedBy: string;
  CreatedDate: Date;
  ModifiedBy: string;
  ModifiedDate: Date;
}

